import { useQuery } from '@tanstack/react-query';
import * as ref from '@core/services/referenceService';
import { selectActiveChannelId, useStoreContextStore } from '@core/store/storeContextStore';

const REF_KEY = 'reference';
const FIVE_MIN = 5 * 60 * 1000;

export function usePaymentMethods() {
  // Business shoppers read the B2B channel's methods, so the key follows it.
  const channelId = useStoreContextStore(selectActiveChannelId);
  return useQuery({
    queryKey: [REF_KEY, 'paymentMethods', channelId],
    queryFn: ref.listPaymentMethods,
    staleTime: FIVE_MIN,
  });
}

export function useCountries(options = {}) {
  return useQuery({
    queryKey: [REF_KEY, 'countries'],
    queryFn: ref.listCountries,
    staleTime: FIVE_MIN,
    ...options,
  });
}

export function useStates(countryCode, { countryName } = {}) {
  return useQuery({
    queryKey: [REF_KEY, 'states', countryCode],
    queryFn: () => ref.listStates(countryCode, { countryName }),
    enabled: Boolean(countryCode),
    staleTime: FIVE_MIN,
  });
}

export function useCities(countryCode, stateCode, { countryName, stateName } = {}) {
  return useQuery({
    queryKey: [REF_KEY, 'cities', countryCode, stateCode],
    queryFn: () => ref.listCities(countryCode, stateCode, { countryName, stateName }),
    enabled: Boolean(countryCode && stateCode),
    staleTime: FIVE_MIN,
  });
}

export function useCurrencies() {
  return useQuery({
    queryKey: [REF_KEY, 'currencies'],
    queryFn: ref.listCurrencies,
    staleTime: FIVE_MIN,
  });
}
